<template>
    <v-carousel cycle hide-delimiters height="auto">
        <v-carousel-item v-for="(img, i) in images" :key="i">
            <v-img
                :src="img.href"
                class="align-start"
                width="800"
                :aspect-ratio="16/9">
                <v-card-title class="white--text jazz-photo-legend">
                    {{ img.legend }}
                </v-card-title>
                <template v-slot:placeholder>
                    <v-row
                        class="fill-height ma-0"
                        align="center"
                        justify="center">
                        <v-progress-circular indeterminate color="grey"></v-progress-circular>
                    </v-row>
                </template>
            </v-img>
        </v-carousel-item>
    </v-carousel>
</template>

<script>
export default {
    name: 'jazz-photos',
    computed: {
        images() {
            return this.$store.getters.photos
        }
    },
    mounted() {
        this.$store.dispatch('photos')
    }
}
</script>

<style>
.jazz-photo-legend {
    background-color: rgba(0, 0, 0, 0.3);
}
</style>
